// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

export function showNode(node, show) {
  if (!node) {
    return;
  }

  node.hidden = !show;
  node.setAttribute('aria-hidden', show ? 'false' : 'true');
}

export function refreshLoadingUi(instance) {
  var isBusy = !!(instance.isLoading || instance.isPreloading || instance.isProgressLoading);
  showNode(instance.loadingNode, isBusy);

  if (instance.list) {
    instance.list.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }
}

export function setLoadingState(instance, isLoading) {
  instance.isLoading = isLoading;
  refreshLoadingUi(instance);
}

export function setPreloadState(instance, isPreloading) {
  instance.isPreloading = isPreloading;
  refreshLoadingUi(instance);
}

export function setProgressState(instance, isProgress, text) {
  instance.isProgressLoading = isProgress;

  if (instance.loadingTextNode) {
    if (isProgress && text) {
      instance.loadingTextNode.textContent = text;
    } else {
      instance.loadingTextNode.textContent = instance.loadingDefaultText;
    }
  }

  refreshLoadingUi(instance);
}

export function shouldAutoInit() {
  var attr = document.documentElement.getAttribute('data-pf-autoinit');
  if (attr === 'false') {
    return false;
  }

  if (window.PandaFilterAutoInit === false) {
    return false;
  }

  return true;
}
